import { PasswordFormData } from "./types";

import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

import { AUTH_API } from "../../../../api/auth";
import AuthButton from "../../../../components/AurhButton";
import {
  EnvelopeIcon,
  KeyIcon,
  NarrowArrow,
} from "../../../../components/Icons";
import Input from "../../../../components/Input";
import { LOCAL_PASS } from "../../../../constants.ts";
import { useAppDispatch } from "../../../../hooks/redux-hooks.ts";
import useAuth from "../../../../hooks/useAuth.tsx";
import { useSSE } from "../../../../layout/SSELayout";
import { fetchProfile } from "../../../../store/slices/profileSlice.ts";
import {
  COOKIE_COMPANY_ID,
  COOKIE_REFRESH_TOKEN_NAME,
  COOKIE_TOKEN_NAME,
  COOKIE_USER_ID,
  setCookie,
} from "../../../../utils/cookie.ts";
import { validationSchema } from "./schema";

import { AuthStepComponentProps } from "../../types.ts";
import { LoginStep } from "../types.ts";

const Initial = ({ email, setStep }: AuthStepComponentProps<LoginStep>) => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { isLoggedIn } = useAuth();
  const { setToken } = useSSE();

  const queryParams = new URLSearchParams(location.search).toString();
  let signupUrl = "/auth/signup";
  if (!isLoggedIn) {
    signupUrl = `/auth/signup${queryParams ? `?${queryParams}` : ""}`;
  }

  const {
    clearErrors,
    control,
    handleSubmit,
    setError,
    formState: { errors, isSubmitting },
  } = useForm<PasswordFormData>({
    resolver: yupResolver<PasswordFormData>(validationSchema),
    defaultValues: {
      email,
      password: LOCAL_PASS || "",
    },
  });

  const onSubmit = async (data: PasswordFormData) => {
    const { data: response, error } = await AUTH_API.signIn(data);
    if (response) {
      // dispatch(setProfile(response.data.user));
      dispatch(fetchProfile());

      setCookie(COOKIE_TOKEN_NAME, response.data.tokenData.token);
      setToken(response.data.tokenData.token);
      setCookie(
        COOKIE_REFRESH_TOKEN_NAME,
        response.data.tokenData.refreshToken,
      );
      setCookie(COOKIE_COMPANY_ID, response.data.user.default_company_id);
      setCookie(COOKIE_USER_ID, response.data.user.userId);
      // setCookie(COOKIE_COMPANY_ID, response.data.user.companies[0].companyId);
      navigate("/overview");
    } else {
      if (
        error?.response?.data?.errorCode === "unauthorized" &&
        error?.response?.data?.message
      ) {
        toast.error(error?.response?.data?.message);
        return;
      }
      if (error?.response?.data?.errorCode === "unverified_user") {
        error?.response?.data?.message &&
          toast.error(error?.response?.data?.message);
        setStep("verification");
      }

      setError("password", {
        message: "Wrong email or password",
      });
    }
  };

  return (
    <>
      <form
        onSubmit={handleSubmit(onSubmit)}
        className="appearAnimation flex flex-col gap-[1.25rem]"
      >
        <Input
          name="email"
          type="email"
          control={control}
          placeholder="Enter your email id here"
          autoComplete={"email"}
          error={errors.email?.message}
          Icon={EnvelopeIcon}
          clearErrors={clearErrors}
        />
        <Input
          name="password"
          autoFocus
          control={control}
          type="password"
          enablePasswordToggle
          placeholder="Password"
          autoComplete={"current-password"}
          error={errors.password?.message}
          Icon={KeyIcon}
          clearErrors={clearErrors}
        />

        {/*<div className={"font-Mulish text-[0.75rem] text-[#FF7B7B]"}>*/}
        {/*  Wrong email or password*/}
        {/*</div>*/}

        <Link
          to="/auth/reset-password"
          className="text-center font-Mulish text-[0.875rem] leading-[1.29rem]"
        >
          Forgot password?
        </Link>

        <div className="flex gap-[1.25rem]">
          <button
            type="button"
            className="flex h-[3rem] w-[3rem] flex-shrink-0 rotate-180 items-center justify-center rounded-md border"
            onClick={() => setStep("initial")}
          >
            <NarrowArrow />
          </button>

          <AuthButton isLoading={isSubmitting} />
        </div>
      </form>

      <p className="appearAnimation flex items-center justify-center gap-[1rem] font-Mulish text-[0.875rem] leading-[1.29rem] text-neutral-400 dark:text-neutral-300">
        Don&#39;t have an account?
        <Link to={signupUrl} className="text-black dark:text-white">
          Sign up
        </Link>
      </p>
    </>
  );
};

export default Initial;
